import { createContext } from 'react';
import { ShopStore } from './store';

export const ShopContext = createContext<ShopStore | null>(null);
